import { Box, Divider } from '@mui/material';
import { resetModal } from 'app/slice/modal.slice';
import TableCustom from 'component/Table/TableCustom';
import TableRowCommon from 'component/Table/TableRowCommon';
import { PAYMENT_CHANNEL, PAYMENT_CHANNEL_GROUP } from 'constants/common';
import { colors } from 'constants/theme';
import _ from 'lodash';
import PageModal from 'new-components/modal/page-modal';
import PaginationTable from 'new-components/pagination/pagination';
import { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { numberToCurrencyFormat } from 'utils/app.utils';
import { dateToView } from 'utils/date.utils';

interface OrderPaymentItem {
    orderPaymentItemId: number
    itemName: string
    amountPaid: number
}

interface PaymentChannel {
    paymentChannelId: number | any
    paymentChannelName?: string
    amountPaid: number
    promotionName?: string
    voucherName?: string
    orderPaymentChannelId?: number
    orderPaymentItems?: OrderPaymentItem[]
}

interface PaymentHistory {
    prefix: string
    paymentNumber: string
    date: string
    createdBy: string
    orderPaymentChannels?: PaymentChannel[]
}

export interface ICancelPaymentProps {
    isShow: boolean
    data: PaymentHistory[]
    onReset?: () => void
}
const initStateErrorMessage = {
    USER_NAME_STRING_EMPTY: '',
    PASSWORD_STRING_EMPTY: '',
    CANCEL_REMARK_STRING_EMPTY: '',
    NOT_FOUND_USER: '',
}
export default function HistoryPayment(props: ICancelPaymentProps) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(5)

    const total = props.data?.length || 0
    const totalPage = Math.max(1, Math.ceil(total / perPage))
    const showPagination = total > 5
    const startIndex = (page - 1) * perPage
    const pagedData = _.slice(props.data || [], startIndex, startIndex + perPage)

    useEffect(() => {
        if (page > totalPage) setPage(1)
    }, [totalPage, page])

    const resetForm = async () => {
        if (props.onReset) props.onReset()
        dispatch(resetModal())
    }

    const renderHistory = (history: PaymentHistory, index: number) => {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                {index > 0 && <Divider
                    className="mx-0 my-2 d-none"
                    sx={{
                        backgroundColor: 'transparent',
                        opacity: 1,
                        borderColor: `${colors.lightGray} !important`,
                        '&:last-of-type': {
                            display: 'block !important'
                        }
                    }}
                />}
                <Box>
                    <Col>#{index + 1}</Col>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Col xs={4} style={{ width: '40%' }}>{t('OVERDUE_DETAIL.NO_BILL')} : {`${history.prefix}${history.paymentNumber}`}</Col>
                    <Col xs={4} style={{ marginLeft: '-30px', width: '30%', paddingLeft: 25 }}>{t('OVERDUE_DETAIL.RECEIPT_DATE')} : {dateToView(history.date)}</Col>
                    <Col xs={4}>{t('OVERDUE_DETAIL.PAYEE')} : {history.createdBy}</Col>
                </Box>
                {/* <TableContainer component={Paper} style={{ boxShadow: 'none', minHeight: 'calc(100% - 65px)', overflow: 'hidden', marginBottom: 5 }}>
                    <Table size="small" sx={{ minWidth: 650 }}>
                        <TableHead  >
                            <TableRow>
                                <TableCell>#{index + 1}</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody  >
                            <TableRow>
                                <TableCell width={150}>เลขใบเสร็จรับเงิน</TableCell>
                                <TableCell >{`${history.prefix}${history.paymentNumber}`}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell width={150}>วันที่รับเงิน</TableCell>
                                <TableCell>{dateToView(history.date)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell width={150}>ผู้รับเงิน</TableCell>
                                <TableCell>{history.createdBy}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer> */}
                {renderOrder(history?.orderPaymentChannels || [])}

            </Box>
        )
    }
    const headCell = [
        { id: 'no', disablePadding: false, label: '#' },
        { id: 'paymentChannelId', disablePadding: false, label: t('OVERDUE_DETAIL.TABLE.TYPE_MONEY_RECEICED') },
        { id: 'amountPaid', disablePadding: false, label: t('OVERDUE_DETAIL.TABLE.AMOUNT_PAID') },
    ]
    const renderOrder = (order: PaymentChannel[]) => {
        const newDataPayment: any = []
        let sumPayment = 0
        order.forEach((item: PaymentChannel) => {
            sumPayment += item?.amountPaid
            const isSpecialChannel = PAYMENT_CHANNEL_GROUP.SPECIAL.includes(item?.paymentChannelId)
            if (isSpecialChannel) {
                const IndexPaymentGroup = newDataPayment.findIndex((info: PaymentChannel) => info?.paymentChannelId === item?.paymentChannelId)
                const isPromotion = item?.paymentChannelId === PAYMENT_CHANNEL.PROMOTION
                const itemName = isPromotion ? item?.promotionName : item?.voucherName
                const channelName = isPromotion
                    ? t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.PROMOTION')
                    : t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.VOUCHER')

                if (IndexPaymentGroup > -1 && newDataPayment[IndexPaymentGroup]) {
                    newDataPayment[IndexPaymentGroup] = {
                        ...newDataPayment[IndexPaymentGroup],
                        orderPaymentItems: [
                            ...newDataPayment[IndexPaymentGroup]?.orderPaymentItems,
                            {
                                orderPaymentItemId: item?.orderPaymentChannelId,
                                itemName,
                                amountPaid: item?.amountPaid,
                            }
                        ]
                    }
                } else {
                    const newChanel = {
                        paymentChannelId: item?.paymentChannelId,
                        paymentChannelName: channelName,
                        amountPaid: item?.amountPaid,
                        orderPaymentItems: [{
                            orderPaymentItemId: item?.orderPaymentChannelId,
                            itemName,
                            amountPaid: item?.amountPaid,
                        }]
                    }
                    newDataPayment.push(newChanel)
                }
            } else {
                newDataPayment.push(item)
            }
        })

        return <>
            <TableCustom
                page={1}
                pageLimit={100}
                sortType={'ASC'}
                sortBy={'createAt'}
                rowCount={100}
                onSort={() => null}
                setPageLimit={() => null}
                setPage={() => null}
                headCells={headCell}
                rowsData={[
                    ..._.map(newDataPayment || [], (data, index: number) => {
                        return [
                            renderPaymentChannel(data, index, 'HEADER'),
                            _.map(_.filter(data?.orderPaymentItems, (item) => item.amountPaid !== 0), renderItem),
                            // renderPaymentChannel(data, index, 'SUMMARY')
                        ]
                    }),
                    renderPaymentChannel({ paymentChannelId: 'summary', amountPaid: sumPayment }, newDataPayment?.length + 1, 'SUMMARY')
                ]}
                hidePagination
            />
        </>
    }

    const renderPaymentChannel = (objData: PaymentChannel | null, index: number, type: "HEADER" | "SUMMARY") => {
        if (!objData) return <></>
        const { paymentChannelId, paymentChannelName, amountPaid } = objData

        let objRenderData: any = {}
        if (type === 'HEADER')
            objRenderData = {
                key: paymentChannelId,
                id: paymentChannelId,
                obj: objData,
                columns: [
                    { option: 'TEXT', align: 'center', label: (index + 1) },
                    { option: 'TEXT', align: 'left', label: paymentChannelName },
                    { option: 'TEXT', align: 'right', label: '' },
                ]
            }
        else
            objRenderData = {
                key: `sum-${paymentChannelId}`,
                id: `sum-${paymentChannelId}`,
                obj: objData,
                columns: [
                    { option: 'TEXT', align: 'center', label: '' },
                    { option: 'TEXT', align: 'left', label: '' },
                    { option: 'TEXT', align: 'right', label: numberToCurrencyFormat(amountPaid) },
                ]
            }
        return <TableRowCommon {...objRenderData} />
    }
    const renderItem = (objData: OrderPaymentItem) => {
        if (!objData) return <></>

        const { orderPaymentItemId, itemName, amountPaid } = objData
        // const rowCheck = _.some(isCheckDiagnosis, (i: number) => Number(i) === Number(patientDiagnosisId))
        // if (!amountPaid) return false
        const objRenderData = {
            key: orderPaymentItemId,
            id: orderPaymentItemId,
            obj: objData,
            // rowSelect: rowCheck,
            columns: [
                { option: 'TEXT', align: 'center', label: '' },
                { option: 'TEXT', align: 'left', label: `- ${itemName}` },
                { option: 'TEXT', align: 'right', label: numberToCurrencyFormat(amountPaid) },
            ]
        }
        return <TableRowCommon {...objRenderData} />
    }

    return props.isShow ? (
        <PageModal
            isOpen={props.isShow}
            handleClose={resetForm}
            size="S"
            title={t('OVERDUE_DETAIL.TITLE_PAID_HISTORY')}
            onCloseSubmit
            onSubmit={{ onClick: () => null }}
            onCancel={{ onClick: resetForm }}
        // overflow
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(90vh - 48px - 40px - 64px - 40px)', overflowY: 'auto' }}>
                {_.map(pagedData, (history, i) => renderHistory(history, startIndex + i))}
            </Box>
            {showPagination && (
                <Box sx={{ marginTop: '16px' }}>
                    <PaginationTable
                        page={page}
                        perPage={perPage}
                        totalPage={total}
                        onChange={(_e, value) => setPage(value)}
                        onPerPageChange={(e) => { setPerPage(Number(e.target.value)); setPage(1) }}
                    />
                </Box>
            )}
        </PageModal>
    ) : <></>
}
